const VolleyballPrograms = [
    {
        id: 1,
        title: "Serve Receive/Defense",
        startDate: "2026-08-01",
        endDate: "2026-12-31",
        date: "Aug 1 - Dec 31",
        ageGroup: "All Ages",
        price: "$20",
        location:
            "ADS Sports Complex, 10251 E Loop 1604 N, Converse, TX 78109",

        locationUrl:
            "https://maps.google.com/?q=10251+E+Loop+1604+N+Converse+TX+78109",

        registrationUrl: "https://adssportscomplex.leagueapps.com/classes/5168850-october-serve-receive--defense"
    },
    {
        id: 2,
        title: "Serving",
        status: "in progress",
        startDate: "2026-08-01",
        endDate: "2026-12-31",
        date: "Aug 1 - Dec 31",
        ageGroup: "ALL AGES",
        price: "$20",
        location:
            "ADS Sports Complex, 10251 E Loop 1604 N, Converse, TX 78109",
        locationUrl:
            "https://maps.google.com/?q=10251+E+Loop+1604+N+Converse+TX+78109",

        registrationUrl: "https://adssportscomplex.leagueapps.com/classes/4986538-serving"
    },
    {
        id: 4,
        title: "Hitting/Blocking and Setting",
        status: "in progress",
        startDate: "2026-08-01",
        endDate: "2026-12-31",
        date: "Aug 1 - Dec 31",
        ageGroup: "All Ages",
        price: "$20",
        location:
            "ADS Sports Complex, 10251 E Loop 1604 N, Converse, TX 78109",
        locationUrl:
            "https://maps.google.com/?q=10251+E+Loop+1604+N+Converse+TX+78109",

        registrationUrl: "https://adssportscomplex.leagueapps.com/classes/5022750-hittingblocking"
    },
    {
        id: 5,
        title: "ADS Volleyball Tryouts",
        status: "in progress",
        startDate: "2026-08-01",
        endDate: "2026-09-30",
        date: "Aug 1 - Sep 30",
        ageGroup: "All Ages",
        price: "$35",
        location:
            "ADS Sports Complex, 10251 E Loop 1604 N, Converse, TX 78109",
        locationUrl:
            "https://maps.google.com/?q=10251+E+Loop+1604+N+Converse+TX+78109",

        registrationUrl: "https://adssportscomplex.leagueapps.com/events/4958225-ads-2026---27-volleyball-tryouts"
    },
    {
        id: 6,
        title: "Positionals (12u - 17u) - Libero, Setters, Pins, Middles",
        startDate: "2026-08-01",
        endDate: "2026-12-31",
        date: "Aug 1 - Dec 31",
        ageGroup: "12U-17U",
        price: "$20",
        location:
            "ADS Sports Complex, 10251 E Loop 1604 N, Converse, TX 78109",
        locationUrl:
            "https://maps.google.com/?q=10251+E+Loop+1604+N+Converse+TX+78109",

        registrationUrl: "https://adssportscomplex.leagueapps.com/classes/5168965-october-positionals-12u---17u---libero-setters-pins-middles"
    },
    {
        id: 7,
        title: "5u - 12u Mighty Titans Volleyball Program (Beginner)",
        startDate: "2026-10-19",
        endDate: "2026-11-30",
        date: "Oct 19 - Nov 30",
        time: "6PM - 7:30PM",
        ageGroup: "5U-12U",
        price: "$200 (Includes T-Shirt)",
        location:
            "ADS Sports Complex, 10251 E Loop 1604 N, Converse, TX 78109",
        locationUrl:
            "https://maps.google.com/?q=10251+E+Loop+1604+N+Converse+TX+78109",

        registrationUrl: "https://adssportscomplex.leagueapps.com/leagues/volleyball/5171249-5u---12u-mighty-titans-volleyball-program-beginner"
    },
    // {
    //     id: 7,
    //     title: "Middle School Tryout Prep Camp — All-Skills",
    //     status: "in progress",
    //     startDate: "2026-08-01",
    //     endDate: "2026-08-22",
    //     date: "Aug 10 - Aug 12",
    //     ageGroup: "12U-17U",
    //     time: "6PM - 8PM",
    //     price: "$250",
    //     location:
    //         "ADS Sports Complex, 10251 E Loop 1604 N, Converse, TX 78109",
    //     locationUrl:
    //         "https://maps.google.com/?q=10251+E+Loop+1604+N+Converse+TX+78109",

    //     registrationUrl: "https://adssportscomplex.leagueapps.com/events/4960817-middle-school-tryout-prep-camp-all-skills---summer-2026"
    // },
    {
        id: 10,
        title: "7U - 12U Titans Volleyball Training Academy",
        status: "upcoming",
        description:
            "12-week session - $200 deposit to reserve your spot and payment plan permitted",
        startDate: "2026-08-26",
        endDate: "2026-11-08",
        date: "Aug 26 - Nov 11",
        time: "6PM - 7PM",
        ageGroup: "7U - 12U",
        price: "$695",
        location:
            "ADS Sports Complex, 10251 E Loop 1604 N, Converse, TX 78109",
        locationUrl:
            "https://maps.google.com/?q=10251+E+Loop+1604+N+Converse+TX+78109",

        registrationUrl: "https://adssportscomplex.leagueapps.com/clubteams/5082501-7u---12u-titans-volleyball-training-academy-intermediateadvance"
    },
];

export default VolleyballPrograms;